import api from '../api';

const BASE_URL = '/api/v2/ai-models';

const AiModelsAPI = {
	listAiModels: (params) => api.get(BASE_URL, { params }),
	getAiModel: (aiModelId) => api.get(`${BASE_URL}/${aiModelId}`),
};

export default AiModelsAPI;
